import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, X, CreditCard } from "lucide-react";

const empty = { name: "", price: "", duration_days: "", description: "" };

export default function Plans() {
  const [plans, setPlans] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => api.get("/plans").then((r) => setPlans(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...form, price: parseFloat(form.price), duration_days: parseInt(form.duration_days, 10) };
      if (form.id) await api.put(`/plans/${form.id}`, payload);
      else await api.post("/plans", payload);
      toast.success("Plan guardado"); setForm(null); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const del = async (p) => { if (window.confirm(`¿Eliminar plan ${p.name}?`)) { await api.delete(`/plans/${p.id}`); load(); } };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div><p className="overline text-[#00f0ff]">Catálogo</p><h1 className="font-display text-5xl">PLANES</h1></div>
        <button data-testid="plan-add-button" onClick={() => setForm({ ...empty })} className="flex items-center gap-2 bg-[#00f0ff] text-black font-bold uppercase text-sm px-5 py-2.5 hover:bg-[#00c2cc]">
          <Plus className="w-4 h-4" /> Nuevo plan
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {plans.map((p) => (
          <div key={p.id} data-testid={`plan-card-${p.id}`} className="bg-[#0a0a0a] border border-white/10 p-6 hover:border-white/30 transition-colors">
            <div className="flex items-start justify-between">
              <CreditCard className="w-6 h-6 text-[#00f0ff]" />
              <div className="flex gap-1">
                <button data-testid={`plan-edit-${p.id}`} onClick={() => setForm(p)} className="p-1.5 hover:bg-white/10"><Pencil className="w-4 h-4" /></button>
                <button data-testid={`plan-delete-${p.id}`} onClick={() => del(p)} className="p-1.5 hover:bg-white/10 text-[#FF3B30]"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
            <p className="text-lg font-bold mt-4">{p.name}</p>
            <p className="font-display text-5xl text-[#39FF14] mt-1">${p.price}</p>
            <p className="text-sm text-white/50 mt-2">{p.duration_days} días de acceso</p>
            {p.description && <p className="text-xs text-white/40 mt-3">{p.description}</p>}
          </div>
        ))}
      </div>

      {form && (
        <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/70 p-4 overflow-y-auto">
          <form onSubmit={save} data-testid="plan-form" className="bg-[#0a0a0a] border border-white/20 w-full max-w-md my-12">
            <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
              <h3 className="font-display text-2xl">{form.id ? "EDITAR PLAN" : "NUEVO PLAN"}</h3>
              <button type="button" onClick={() => setForm(null)}><X className="w-5 h-5 text-white/50" /></button>
            </div>
            <div className="p-6 space-y-4">
              <div><label className="overline block mb-1.5">Nombre *</label>
                <input data-testid="plan-field-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-[#121212] border border-white/10 px-3 py-2 text-sm focus:border-[#00f0ff] focus:outline-none" /></div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="overline block mb-1.5">Precio *</label>
                  <input data-testid="plan-field-price" required type="number" step="0.01" value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} className="w-full bg-[#121212] border border-white/10 px-3 py-2 text-sm focus:border-[#00f0ff] focus:outline-none" /></div>
                <div><label className="overline block mb-1.5">Duración (días) *</label>
                  <input data-testid="plan-field-days" required type="number" value={form.duration_days} onChange={(e) => setForm({ ...form, duration_days: e.target.value })} className="w-full bg-[#121212] border border-white/10 px-3 py-2 text-sm focus:border-[#00f0ff] focus:outline-none" /></div>
              </div>
              <div><label className="overline block mb-1.5">Descripción</label>
                <input data-testid="plan-field-desc" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="w-full bg-[#121212] border border-white/10 px-3 py-2 text-sm focus:border-[#00f0ff] focus:outline-none" /></div>
            </div>
            <div className="flex justify-end gap-2 px-6 py-4 border-t border-white/10">
              <button type="button" onClick={() => setForm(null)} className="border border-white/20 px-5 py-2.5 text-sm hover:bg-white/5">Cancelar</button>
              <button type="submit" data-testid="plan-save-button" className="bg-[#00f0ff] text-black font-bold uppercase text-sm px-6 py-2.5 hover:bg-[#00c2cc]">Guardar</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
